import {
    validateEmail,
    validateFirstName,
    validateLastName
} from '../Shared/validations.js';

const validate = values => {
    const errors = {
        ...validateFirstName(values),
        ...validateLastName(values),
        ...validateEmail(values)
    };

    return errors;
};

export default validate;
